import React from 'react'
import { Link } from 'react-router-dom'

import gremlinLogo from 'assets/logos/gremlin-logo-white.svg'
import Image from 'components/common/Image'
import theme from 'theme'

export const DrawerGremlinLogoLink: React.FC<{
  url: string
}> = ({ url }) => {
  return (
    <Link
      css={{
        alignItems: 'center',
        display: 'flex',
        height: 'var(--header-height)',
        justifyContent: 'center',
        paddingLeft: theme.space[1],
        paddingRight: theme.space[1]
      }}
      data-testid="nav-dashboard"
      to={url}
    >
      <Image
        alt="Gremlin"
        css={{
          maxWidth: '75%'
        }}
        src={gremlinLogo}
      />
    </Link>
  )
}
